import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import SideBar from "../dashboardcomponents/SideBar";
import { useDispatch, useSelector } from "react-redux";
import DashboardHeader from "../dashboardcomponents/DashboardHeader";
import { getAgentStatus } from "../../store/features/getAgentStatus";
import { coUserUpdateStatus } from "../../store/features/coUserUpdateStatus";
import HeaderAlertBar from "../dashboardcomponents/HeaderAlertBar";
import { createAppSocket, emitAgentSetup } from '../../api/createAppSocket';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import { useLocation } from "react-router-dom";
import NotificationOverlay from "../dashboardcomponents/Notifications/NotificationOverlay";
import InterceptingOutlet from "../routing/InterceptingOutlet";
import { useNotificationOverlayOpen } from "../../context/NotificationOverlayContext";

function DashboardComponents(props) {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.loginToken);
  const [acceptChat, setAcceptChat] = useState(true);
  const [loading, setLoading] = useState(false);
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(true);
  const [showReconnected, setShowReconnected] = useState(false);
  const prevConnectedRef = useRef(true);
  const location = useLocation();
  const pathname = location.pathname;
  const isNotificationsOverlay = useNotificationOverlayOpen();
  const backgroundPath =
    location.state?.backgroundLocation?.pathname ||
    (isNotificationsOverlay ? "/dashboard" : pathname);
  // Only Ticket V2 / Chat V2 routes hide the global header — not analytics/tickets
  // When notifications overlay is open, use the background page for this check
  const isTicketV2Url =
    backgroundPath === "/tickets" ||
    backgroundPath.startsWith("/tickets/") ||
    backgroundPath.includes("/ticketv2");
  const isChatV2Url =
    pathname === "/chat" ||
    pathname.startsWith("/chat/") ||
    pathname.includes("/chatv2");
  const isFullBleedWorkspace = isTicketV2Url || isChatV2Url;

  useEffect(() => {
    if (socketRef.current) {
      socketRef.current.disconnect();
      socketRef.current = null;
    }

    if (userData?.response?.user?._id) {
      socketRef.current = createAppSocket({
        transports: ["websocket"],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 500,
      });

      emitAgentSetup(socketRef.current);

      socketRef.current.on("connected", () => {
        console.log("Socket Connected Successfully");
      });
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [userData?.response?.user?._id]);

  useEffect(() => {
    const fetchStatus = async () => {
      if (!userData?.response?.user?._id) return;
      const res = await dispatch(
        getAgentStatus({ id: userData.response.user._id })
      );
      console.log("Agent status response: in dahsbord", res);
      if (res?.payload?.accept_chat === false) {
        setAcceptChat(false);
      } else {
        setAcceptChat(true);
      }
    };
    fetchStatus();
  }, [dispatch, userData]);

  useEffect(() => {
    if (!socketRef.current) return;
    const handleStatus = (agentId, status) => {
      if (agentId === userData?.response?.user?._id) {
        setAcceptChat(status);
      }
    };
    socketRef.current.on("get-status", handleStatus);
    return () => {
      socketRef.current?.off("get-status", handleStatus);
    };
  }, [userData]);

  const handleAcceptChats = async () => {
    if (!socketRef.current || !userData?.response?.user?._id) return;
    // setLoading(true);
    socketRef.current.emit("update-status", userData.response.user._id, true);
    setAcceptChat(true);

    await dispatch(
      coUserUpdateStatus({
        id: userData.response.user._id,
        requestHeaders: { accept_chat: true },
      })
    );
    // setLoading(false);
  };

  useEffect(() => {
    const handleOnline = () => setIsConnected(true);
    const handleOffline = () => setIsConnected(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // Show a temporary green banner after reconnection
  useEffect(() => {
    let bannerTimeoutId;
    let reloadTimeoutId;
    if (isConnected && prevConnectedRef.current === false) {
      setShowReconnected(true);
      bannerTimeoutId = setTimeout(() => setShowReconnected(false), 3000);
      reloadTimeoutId = setTimeout(() => {
        if (navigator.onLine && isConnected) {
          window.location.reload();
        }
      }, 2500);
    }
    prevConnectedRef.current = isConnected;
    return () => {
      if (bannerTimeoutId) clearTimeout(bannerTimeoutId);
      if (reloadTimeoutId) clearTimeout(reloadTimeoutId);
    };
  }, [isConnected]);



  return (
    <>
      {isConnected && !showReconnected &&(
        <HeaderAlertBar
          acceptChat={acceptChat}
          loading={loading}
          onAcceptChats={handleAcceptChats}
        />
      )}

      {!isConnected && (
        <div
          style={{
            width: "100%",
            height: "40px",
            flexShrink: 0,
            background: "#FF4D4F",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
          }}
        >
          <WifiOffIcon style={{ marginRight: 8 }} />
          Connection lost. Trying to reconnect...
        </div>
      )}
      {isConnected && showReconnected && (
        <div
          style={{
            width: "100%",
            height: "40px",
            flexShrink: 0,
            background: "#2e7d32",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
          }}
        >
          <CheckCircleIcon style={{ marginRight: 8 }} />
          You're back online
        </div>
      )}

      <div className="dashboard_container_main">
        <div className="dashboard_left_container">
          <SideBar />
        </div>
        <div className="dashboard_right_container" style={{ position: "relative" }}>
          {
           isFullBleedWorkspace ? null : (
            <DashboardHeader />
           )
          }
          <div className="dashboard_content_container" style={{ height: isFullBleedWorkspace && "calc(100vh - 0px)" }}>
            <InterceptingOutlet isOverlay={isNotificationsOverlay} />
          </div>
          {isNotificationsOverlay ? <NotificationOverlay /> : null}
        </div>
      </div>
    </>
  );
}

export default DashboardComponents;
